module.exports = __webpack_public_path__ + "img/grand-cancun-hotel-4.f5822682.jpg";